export const CATEGORY = [
  { value: "a", title: "Category A" },
  { value: "b", title: "Category B" },
  { value: "c", title: "Category C" },
  { value: "d", title: "Category D" },
  { value: "e", title: "Category E" },
];
export const DEFAULT_CATEGORY = "b";
